import { wrapInQuotes, formatAddressInlineAsText, formatWageText, formatTippedWageText } from '../../../../common/helpers'

export const csvHeaders = Object.freeze({
  common: [
    'Date of Change',
    'Locations Affected',
    'Address',
    'Law(s)',
    'Region Type',
    'State Affected',
    'Region Name',
    'New Wage',
    'Min. Wage'
  ],
  tipped: [
    'New Tip. Wage',
    'Tip. Wage'
  ]
})

export const createNotificationsCsvRows = (tipped, notifications) => {
  const rows = []

  const headers = tipped ? csvHeaders.common.concat(csvHeaders.tipped) : csvHeaders.common

  rows.push(headers.join(','))

  notifications.filter((notification) => {
    const hasIndexedWage = notification.notificationNewWage && notification.notificationNewWage.indexed
    const hasIndexedTippedWage = notification.notificationNewTipWage && notification.notificationNewTipWage.indexed
    return !hasIndexedWage && !hasIndexedTippedWage
  })
    .map((notification) => {
      notification.locationsData.map((location) => {
        const commonColumns = [
          wrapInQuotes(notification.notificationDate),
          wrapInQuotes(location.name),
          wrapInQuotes(formatAddressInlineAsText(location)),
          wrapInQuotes(notification.law),
          wrapInQuotes(notification.jurisdictionType),
          wrapInQuotes(location.state),
          wrapInQuotes(notification.name),
          wrapInQuotes(formatWageText(notification.notificationNewWage)),
          wrapInQuotes(formatWageText(notification.notificationPrevailingWage))
        ]
        const tippedColumns = [
          notification.hasMultipleTippedWages ? wrapInQuotes(formatTippedWageText(notification.notificationNewTipWage)) : wrapInQuotes(formatWageText(notification.notificationNewTipWage)),
          notification.hasMultipleTippedWages ? wrapInQuotes(formatTippedWageText(notification.notificationPrevailingTipWage)) : wrapInQuotes(formatWageText(notification.notificationPrevailingTipWage))
        ]
        const columns = tipped ? commonColumns.concat(tippedColumns) : commonColumns
        rows.push(columns.join(','))
      })
    })

  return rows
}
